import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import H5 from '../elements/headings/H5';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UITooltipHeader(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(H5, Object.assign({}, rest, {
    className: classNames('private-tooltip__heading', className)
  }));
}
UITooltipHeader.displayName = 'UITooltipHeader';